import { CheckIcon, getCheckColor } from "./check_icon";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function CustomBlock() {
  const {
    customSelected,
    setCustomSelected,
    denominationBorderClass,
    externalProps,
    internalState,
  } = useDenominationGridContext();

  const { isDarkTheme } = externalProps;
  const { setSelectedAmount } = internalState;

  return (
    <div
      class={`${denominationBorderClass} border border-neutral-200 darkTheme:border-baseTertiaryLight dark:border-baseDark  `}
      classList={{
        hidden: customSelected(),
      }}
      onClick={() => {
        setCustomSelected(true);
        document.getElementById("custom-amount-input")?.focus();
        setSelectedAmount(null);
      }}
    >
      <div class="font-semibold">
        <span>Custom</span>
      </div>
      <div
        class="absolute right-[9px] top-[1px] h-[6px] w-[9px]"
        classList={{
          "group-hover:block": !customSelected(),
          block: customSelected(),
          hidden: !customSelected(),
          [getCheckColor({
            isSelected: customSelected(),
            isDarkTheme: isDarkTheme ?? false,
          })]: true,
        }}
      >
        <CheckIcon />
      </div>
    </div>
  );
}
